import React from "react";
import clsx from "clsx";
import { SkewedTextBox } from "./SkewedTextBox";

interface LayoutProps {
  title: string;
  fullWidth?: boolean;
  children: React.ReactNode;
}

export default function Layout({ title, fullWidth, children }: LayoutProps) {
  return (
    <div
      className={clsx(
        "pt-8 px-0 pb-16 [&:nth-of-type(even)]:bg-page [&:nth-of-type(odd)]:bg-steel-200",
        { "overflow-x-hidden": fullWidth },
      )}
    >
      <div
        className={clsx("w-full mx-auto px-4", fullWidth ? "max-w-[1200px]" : "max-w-[900px]")}
      >
        <div className="flex justify-center mb-14">
          <SkewedTextBox variant="h3" color="secondary">
            {title}
          </SkewedTextBox>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}
